module.exports = __webpack_public_path__ + "static/media/billing.6624666b.svg";